import React from "react";
import {Fade, LinearProgress, Tab, Tabs,} from "@mui/material";
import SwipeableViews from 'react-swipeable-views';
import ProfilePanel from "./ProfilePanel";
import {RecentlyViewed} from "./RecentlyViewed";

let index = 0;
let isTouching = false;
export default function ProfileView({
                                        favoriteSearchIndex,
                                        searchParams,
                                        setSearchParams,
                                        updateUser,
                                        updateUserSubscription,
                                        handleClose,
                                        handleLogout,
                                        blockedSellers,
                                        blockedCountries,
                                        savedSearches,
                                        loadingUserData,
                                        privacy, open, subscriptions, value, setValue, recentItems, auth, preferredEbay
                                    }) {
    const handleChange = (event, newValue) => {
        index = newValue;
        isTouching = false;
        setValue(newValue);
    };

    return (<>
        <div style={{position: "fixed", left: 0, height: "100%", zIndex: 101, width: 20, opacity: 0}}/>
        <div style={{
            position: "fixed",
            right: 0,
            background: "black",
            height: "100%",
            zIndex: 101,
            width: 20,
            opacity: 0
        }}/>
        <SwipeableViews onTouchStart={() => {
            isTouching = true;
        }} onTransitionEnd={() => {
            setValue(index);
            isTouching = false;
        }}
                        onChangeIndex={value => {
                            if (isTouching) index = value
                        }} style={{height: '100%'}}
                        containerStyle={{height: '100%'}} index={value}>
            <div style={{height: '100%'}}>
                <ProfilePanel loadingUserData={loadingUserData} isViewing={value === 0} subscriptions={subscriptions} open={open}
                              favoriteSearchIndex={favoriteSearchIndex} searchParams={searchParams}
                              setSearchParams={setSearchParams} handleClose={handleClose} data={savedSearches}
                              updateUser={updateUser} updateUserSubscription={updateUserSubscription}
                              nullMessage="No Saved Searches" index={0}/>
            </div>
            <div style={{height: '100%'}}>
                <RecentlyViewed loadingUserData={loadingUserData} isViewing={value === 1} auth={auth} recentItems={recentItems}
                                preferredEbay={preferredEbay}/>
            </div>
            <div style={{height: '100%'}}>
                <Fade in={open && value === 2} unmountOnExit>
                    <div style={{height: '100%'}}>
                        <ProfilePanel loadingUserData={loadingUserData} isViewing={true} open={open} data={blockedSellers} updateUser={updateUser}
                                      nullMessage="No Blocked Sellers"
                                      index={1}/>
                    </div>
                </Fade>
            </div>
            <div style={{height: '100%'}}>
                <Fade in={open && value === 3} unmountOnExit>
                    <div style={{height: '100%'}}>
                        <ProfilePanel loadingUserData={loadingUserData} isViewing={true} open={open} data={blockedCountries} updateUser={updateUser}
                                      nullMessage="No Blocked Countries"
                                      index={2}/>
                    </div>
                </Fade>
            </div>
        </SwipeableViews>
        <div style={{zIndex: 102, margin: "auto", marginBottom: "0.5em", overflow: "visible", width: "100%"}}>
            <Tabs variant="scrollable" scrollButtons allowScrollButtonsMobile value={value}
                  onChange={handleChange}>
                <Tab label={`Saved Searches (${savedSearches?.length ?? 0})`}/>
                <Tab label={`Recently Viewed`}/>
                <Tab label={`Blocked Sellers (${blockedSellers?.length ?? 0})`}/>
                <Tab label={`Blocked Countries (${blockedCountries?.length ?? 0})`}/>
            </Tabs>
        </div>
        <div style={{height: "4.5px"}}>
            <Fade unmountOnExit in={loadingUserData}><LinearProgress/></Fade>
        </div>
    </>)
}